import { Icon, styled } from "@cirrus/ui-kit"

import { map } from "ramda"
import { createElement as h } from "react"

import { AlertV1, AlertType } from "@cirrus/ui-kit/AlertV1"

const Wrapper = styled("div")({
  zIndex: 999,
  position: "fixed",
  top: "80px",
  left: 0,
  right: 0,
  margin: "auto",
  width: 536,
  textAlign: "center",
})

const SpinnerIcon = styled(Icon)({
  "@keyframes iconSpin": {
    from: { transform: "rotate(0deg)" },
    to: { transform: "rotate(359deg)" },
  },

  spinnerIcon: {
    display: "inline-block",
    animation: "$iconSpin 2s infinite linear",
  },
})

const rendered = map((notification) =>
  h(
    AlertV1,
    { key: notification.id, type: AlertType.info },
    h("p", null, notification.message, " ", h(SpinnerIcon, { name: "spinner" })),
  ),
)

export const LoadingNotifications = ({ list }) => h(Wrapper, null, rendered(list))
